import { notification } from "antd";
import React, { createContext, useContext, useMemo } from "react";

// ---------------------------------------------------------------------------
// Context + Provider + Hook – single notification instance for the whole app
// ---------------------------------------------------------------------------

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [api, contextHolder] = notification.useNotification();

  const ctx = useMemo(
    () => ({
      success: (message, description = "") =>
        api.success({
          message,
          description,
          placement: "topRight",
          duration: 3,
        }),
      error: (message, description = "") =>
        api.error({ message, description, placement: "topRight", duration: 4 }),
      warning: (message, description = "") =>
        api.warning({
          message,
          description,
          placement: "topRight",
          duration: 3,
        }),
      info: (message, description = "") =>
        api.info({ message, description, placement: "topRight", duration: 3 }),
    }),
    [api]
  );

  return (
    <ToastContext.Provider value={ctx}>
      {contextHolder}
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast must be used within a <ToastProvider>");
  }
  return ctx;
};
